import axios from "@/axios";

export default {
  state: {
    categories: [],
    uploads: [],
    selectedCategory: null,
    selectedUpload: null,
    loadingCategories: true,
    loadingUploads: true,
  },
  mutations: {
    setTemplatesCategories(state, categories) {
      state.categories = categories;
    },
    setTemplatesUploads(state, uploads) {
      state.uploads = uploads;
    },
    setTemplatesAddCategory(state, category) {
      state.categories.push(category);
    },
    setTemplatesSelectedUpload(state, upload_id) {
      const upload = state.uploads.find((upload) => upload.id == upload_id);
      state.selectedUpload = upload;
    },
    setTemplatesSelectedCategory(state, category_id) {
      function findCategoryRecursive(categories, category_id) {
        for (const category of categories) {
          if (category.id == category_id) {
            return category;
          }
          if (category.children && category.children.length > 0) {
            const found = findCategoryRecursive(category.children, category_id);
            if (found) {
              return found;
            }
          }
        }
        return null;
      }

      const category = findCategoryRecursive(state.categories, category_id);
      state.selectedCategory = category;
    },
    setTemplatesCategoriesLoading(state, isLoading) {
      state.loadingCategories = isLoading;
    },
    setTemplatesUploadsLoading(state, isLoading) {
      state.loadingUploads = isLoading;
    },
  },
  actions: {
    templatesFetchCategories(ctx) {
      ctx.commit("setTemplatesCategoriesLoading", true);
      return new Promise((resolve, reject) => {
        axios
          .get("/api/view/hierarchy/simple")
          .then((response) => {
            ctx.commit("setTemplatesCategories", response.data);
            ctx.commit("setTemplatesCategoriesLoading", false);
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
    templatesFetchUploads(ctx, category_id) {
      ctx.commit("setTemplatesUploadsLoading", true);
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/node/${category_id}/upload`)
          .then((response) => {
            const uploads = response.data;
            ctx.commit("setTemplatesUploads", uploads);
            ctx.commit("setTemplatesUploadsLoading", false);
            if (uploads && uploads.length > 0) {
              const mostRecentUpload = uploads.reduce((newest, current) => {
                const newestDate = new Date(newest.upload_date);
                const currentDate = new Date(current.upload_date);
                return currentDate > newestDate ? current : newest;
              }, uploads[0]);
              if (mostRecentUpload) {
                ctx.commit("setTemplatesSelectedUpload", mostRecentUpload.id);
              }
            }
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
    templatesDeleteCategory(ctx, categoryId) {
      ctx.commit("setTemplatesSelectedCategory", null);
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/hierarchy/node/${categoryId}`)
          .then(() => {
            ctx.dispatch("templatesFetchCategories");
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
    templatesDeleteUpload(ctx, { categoryId, uploadId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/upload/${uploadId}`)
          .then(() => {
            ctx.dispatch("templatesFetchUploads", categoryId);
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
    templatesRunGenerate(ctx, { categoryId, uploadId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/service/node/${categoryId}/upload/${uploadId}/generate`)
          .then(() => {
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
    async templatesCreateUpload(ctx, data) {
      const upload = () => {
        const formData = new FormData();
        formData.append("file", data.file);
        return new Promise((resolve, reject) => {
          axios
            .post(
              `/api/service/upload?node_id=${data.categoryId}&decimal_seperator=${data.seperator}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            )
            .then((response) => {
              resolve(response.data.id);
            })
            .catch(() => {
              reject();
            });
        });
      };

      const annotate = (uploadId) => {
        const annotateData = { identifier_features: data.identifiers };
        return new Promise((resolve, reject) => {
          axios
            .post(`/api/view/upload/${uploadId}/powerid`, annotateData)
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      };

      const stage = (uploadId) => {
        return new Promise((resolve, reject) => {
          axios
            .patch(`/api/upload/${uploadId}`, { stage: 3 })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      };

      const upload_id = await upload();
      await annotate(upload_id);
      await stage(upload_id);

      ctx.dispatch("templatesFetchUploads", data.categoryId);
    },
    templatesCreateCategory(ctx, newCategory) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/hierarchy/node", newCategory)
          .then((_) => {
            ctx.dispatch("templatesFetchCategories");
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
    templatesChangeCategoryParent(ctx, { category, parent }) {
      if (category.id == parent.id) {
        return;
      }
      const data = { hierarchy_id: category.id, parent_id: parent.id };
      return new Promise((resolve, reject) => {
        axios
          .post("/api/services/hierarchy/parent", data)
          .then((_) => {
            ctx.dispatch("templatesFetchCategories");
            resolve();
          })
          .catch((_) => {
            reject();
          });
      });
    },
  },
  getters: {
    getTemplatesCategories(state) {
      return state.categories;
    },
    getTemplatesUploads(state) {
      return state.uploads;
    },
    getTemplatesSelectedCategory(state) {
      return state.selectedCategory;
    },
    getTemplatesSelectedUpload(state) {
      return state.selectedUpload;
    },
    getTemplatesCategoriesLoading(state) {
      return state.loadingCategories;
    },
    getTemplatesUploadsLoading(state) {
      return state.loadingUploads;
    },
  },
};
